import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className="pt-32 pb-12 px-4 relative overflow-hidden bg-brand-gray">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 bg-brand-orange/5"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2 bg-gray-200"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        {subtitle && (
          <div className="flex items-center gap-3 mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <span className="h-0.5 w-12 bg-brand-orange"></span>
            <span className="text-brand-orange font-bold uppercase tracking-[0.2em] text-sm">{subtitle}</span>
          </div>
        )}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter leading-[0.9] text-brand-dark animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          {title.split('//').map((part, i) => (
             <span key={i} className="block">{part}</span>
          ))}
        </h1>
      </div>
    </div>
  );
};